import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Button } from "components/Forms/StyledComponents";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export default function ReminderWarningModal({
  isOpen,
  onContinue,
  onClose,
}: Props) {
  const { t } = useTranslation("rules");

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle
        disableTypography
        style={{ width: "100%", position: "relative" }}
      >
        <Typography variant="h6">
          {t("sendDelay.reminderWarning.title")}
        </Typography>
        <IconButton
          size="small"
          style={{ position: "absolute", top: "1rem", right: "1rem" }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="caption">
          {t("sendDelay.reminderWarning.desc")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          variant="text"
          wording={t("common:cancel")}
          onClick={onClose}
        />
        <Button
          size="small"
          wording={t("common:continue")}
          onClick={onContinue}
        />
      </DialogActions>
    </Dialog>
  );
}
